import { SubmitModal } from 'Components/modal/SubmitModal/SubmitModal'
import { createReactElement, UpdatableReactElement } from 'shared/utils/react.utils'
import { BaseModalController, IModal, ModalContext } from '../Modal'
import { NotificationPropsType, TaskMode } from 'Types/Tasks.types'
import type { CSATFeedbackData } from 'Types/CSAT.types'

export type SubmitModalMetaData = {
    taskMode?: TaskMode
    isAccept?: boolean
    confidenceLevel?: string
    comment?: string
}

export class SubmitModalController
    extends BaseModalController<SubmitModalMetaData>
    implements IModal<SubmitModalMetaData>
{
    static Id = 'submit-modal' as const
    constructor(modalContext: ModalContext) {
        super(modalContext, SubmitModalController.Id)
        this.metaData = { isAccept: false }
    }

    createElement(): UpdatableReactElement {
        const onConfirm = (payload: {
            confidenceLevel?: string
            comment: string
            feedbackData?: CSATFeedbackData
        }) => {
            this.onSubmitModalClose('submit', payload)
        }
        const onCancel = () => {
            this.onSubmitModalClose('dismiss')
        }

        return createReactElement(SubmitModal, {
            ...this.modalContext,
            onConfirm,
            onCancel,
            getVisibility: this.getVisibility.bind(this),
            getMetaData: this.getMetaData.bind(this),
        })
    }

    onSubmitModalClose(
        action: 'submit' | 'dismiss' = 'dismiss',
        payload?: {
            confidenceLevel?: string
            comment: string
            feedbackData?: CSATFeedbackData
        }
    ) {
        const draftContainer = this.modalContext.task.taskState.getDraftOutputContainer()
        if (action === 'submit') {
            if (!draftContainer || !payload) {
                return
            }

            const step = this.modalContext.studio.taskConfig.assignment.step
            step && this.modalContext.task.handleDecisionAndSupplementForStepType(step, payload)

            this.modalContext.task.submitTask({
                onComplete: (notifications?: NotificationPropsType) => {
                    this.modalContext.task.navigateTask(notifications)
                },
                ...(payload.feedbackData ? { feedbackData: payload.feedbackData } : {}),
            })
        }

        this.setVisibility(false)
    }
}
